import { Component } from "@angular/core";

@Component({
  selector: "bit-tab-group",
  templateUrl: "./tab-group.component.html",
})
export class TabGroupComponent {}
